<template>
  <Banner v-if="route.name === 'catalog-slug' && user && user.is_staff"
    ><p>
      <a :href="`/wadmin/catalogue/product/${product.product_id}/change/`"
        >Edit this product
      </a>
      <span v-if="product.in_hidden_occasion">(in Ninja Occasion)</span>
    </p></Banner
  >
</template>

<script>
import Banner from '~/components/Header/Banner.vue'
export default {
  name: 'ProductEditBanner',
  components: {
    Banner,
  },
  props: {
    user: {
      type: [Object, Boolean],
      required: true,
    },
    route: {
      type: Object,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
  },
}
</script>
